const styles = {
  container: {
    padding: '4rem',
    width: 'auto !important',
    margin: '8rem 0 4rem 0',
    backgroundColor: '#fff',
    borderRadius: '0.25em',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06);',
    '&.ui .grid': {
      marginTop: '1rem !important',
    },
  },
  chartPlaceholder: {
    boxShadow: 'none',
  },
  mainHeader: {
    color: '#585858 !important',
    fontSize: '1.125em !important',
    background: '#f7f7f7',
  },
  searchContainer: {
    textAlign: 'right',
  },
  searchInput: {
    marginLeft: '1rem',
    marginRight: '1rem',
  },
  header: {
    fontSize: '1.875rem !important',
    fontWeight: 'normal !important' as 'normal',
    marginTop: '0 !important',
  },
  userNotFound: {
    display: 'flex',
    margin: 'auto',
  },
};

export default styles;
